export default {"src":"/_next/static/media/help-center.4f2d230e.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};